import { UserState } from 'generated/graphql';
import { UserType } from 'v2/core/entities/user';

export const isValidUserTypeAndState = (
  userType: UserType,
  userState: UserState,
): boolean => {
  if (
    userType !== UserType.Manager &&
    userType !== UserType.Editor &&
    userType !== UserType.Member &&
    userType !== UserType.Viewer
  ) {
    return false;
  }

  if (userState !== UserState.Active && userState !== UserState.Suspended) {
    return false;
  }

  return true;
};
